import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  REGISTER_SET_LOADING,
} from '../actions/types'

const initialState = {
  loading: false,
  error: null
};

// eslint-disable-next-line
export default (state = initialState, action) => {
  switch (action.type) {
    case REGISTER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null
      }
    case REGISTER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case REGISTER_SET_LOADING:
      return{
        ...state,
        loading: true
      }
    default:
      return state;
  }
}